import { Button, Icon, NonIdealState, Spinner } from "@blueprintjs/core";
import { useLayoutEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { useFlyoutPdfState } from "../PdfContextProvider/context-flyout-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export function FlyoutPdfDocument() {
  const ref = useRef<HTMLDivElement>(null);
  const {
    file,
    error,
    loading,
    decrementPage,
    incrementPage,
    onLoadSuccess,
    pageCurrent,
    setPage,
  } = useFlyoutPdfState();

  const [width, setWidth] = useState<number>(0);

  useLayoutEffect(() => {
    const updateOrientation = () => {
      if (ref.current) {
        setWidth(ref.current.clientWidth);
      }
    };

    updateOrientation();

    window.addEventListener("resize", updateOrientation);
    return () => {
      window.removeEventListener("resize", updateOrientation);
    };
  }, []);

  if (loading) {
    return <Spinner size={100} />;
  }

  if (error) {
    return (
      <NonIdealState
        icon="error"
        title="Error"
        description="Error loading PDF"
      />
    );
  }

  return (
    <div className="relative h-full w-full overflow-hidden bg-black">
      <div className="absolute top-0 left-0 h-full w-full flex flex-col items-center justify-center">
        <Spinner size={200} />
      </div>
      <div ref={ref} className="absolute top-0 left-0 h-full w-full">
        <Document
          file={file}
          onLoadError={(error) => console.error(error)}
          onLoadSuccess={onLoadSuccess}
        >
          <Page pageNumber={pageCurrent} width={width} />
        </Document>
      </div>
      <div className="absolute bottom-0 left-0 flex flex-row w-full p-8 items-center justify-center">
        <Button
          className="mr-8 outline-none"
          intent="none"
          minimal
          onPointerDown={decrementPage}
        >
          <Icon icon="chevron-left" size={64} />
        </Button>
        <Button
          className="mr-8 outline-none"
          intent="primary"
          minimal
          onPointerDown={() => setPage(1)}
        >
          <Icon icon="home" size={64} />
        </Button>
        <Button
          className="outline-none"
          intent="none"
          minimal
          onPointerDown={incrementPage}
        >
          <Icon icon="chevron-right" size={64} />
        </Button>
      </div>
    </div>
  );
}
